<template>
	<div v-if="showEditor" class="editor-container ml-2">
		<v-autocomplete
			v-model="newTagName"
			:items="tagList"
			:search-input.sync="search"
			item-text="name"
			item-value="name"
			placeholder="Tag Name"
			hide-no-data
			hide-details
			autofocus
			@blur="onBlurEditor"
			@change="onChange"
			@keyup="onKeyUp"
		></v-autocomplete>
	</div>
	<span v-else>
		<v-chip label v-if="tag" small class="tag" :close="!readOnly" v-model="model">{{ tag.name }}</v-chip>
		<v-chip label v-else small class="tag add" @click="onAddClick">{{ _addText }}</v-chip>
	</span>
</template>

<script>
	export default {
		props: {
			tag: {
				required: false,
				type: Object
			},
			addText: {
				required: false,
				type: String
			},
			tagList: {
				required: false,
				type: Array
			},
			readOnly: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				showEditor: false,
				newTagName: null,
				model: true,
				search: null
			};
		},
		watch: {
			model() {
				this.onRemoveTag();
			}
		},
		computed: {
			_addText() {
				return !this.addText ? 'Add tag' : this.addText;
			}
		},
		methods: {
			onAddClick() {
				this.showEditor = true;
			},
			onBlurEditor() {
				if (this.newTagName || this.search) {
					const result = this.newTagName ? this.newTagName : this.search;
					this.$emit('onAddTag', result);
				}
				this.newTagName = null;
				this.showEditor = false;
			},
			onRemoveTag() {
				this.$emit('onRemoveTag', this.tag.id);
			},
			onChange() {
				this.$emit('onAddTag', this.newTagName);
				this.newTagName = null;
                    this.search = null;
				this.showEditor = false;
			},
			onKeyUp(e) {
				if (e.keyCode === 13) {
					this.$emit('onAddTag', this.search);
					this.newTagName = null;
					this.showEditor = false;
				}
			}
		}
	};
</script>

<style scoped lang="scss">
	.editor-container {
		display: inline-block;
	}

	.tag {
		&.add {
			&:hover {
				background-color: rgba(0, 0, 0, 0.3);
			}
		}
		&.v-chip {
			.v-chip__content {
				cursor: pointer !important;
			}
		}
	}
</style>
<style>
	.v-chip.tag.add .v-chip__content {
		cursor: pointer !important;
	}
</style>
